"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const common_1 = require("../StatusBar/common");
const utilities_1 = require("../../utilities");
const utilities_2 = require("../../Themes/utilities");
const polished_1 = require("polished");
const Icon_1 = tslib_1.__importDefault(require("../../Icon"));
const react_1 = tslib_1.__importDefault(require("react"));
const StatusBar_1 = tslib_1.__importDefault(require("../StatusBar"));
const styled_components_1 = tslib_1.__importStar(require("../../Themes/styled-components"));
const AppName = styled_components_1.default.div `
  font-size: ${(0, polished_1.rem)(14)};
  font-weight: normal;
  max-width: 100%;
  text-align: center;
  margin-top: ${(0, polished_1.rem)(7)};

  display: -webkit-box;
  max-height: ${(0, polished_1.rem)(35)};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
`;
const Wrapper = styled_components_1.default.div `
  padding: ${(0, polished_1.rem)(16)};
  overflow-y: auto;
  max-height: 100%;
  ${(0, utilities_2.mb)('s')} {
    max-height: ${(0, polished_1.rem)(310)};
  }
`;
const Grid = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: ${(0, polished_1.rem)(96)};
  grid-gap: ${(0, polished_1.rem)(8)};
  min-width: 0;
`;
const AppWrapper = styled_components_1.default.a `
  min-width: 0;
  user-select: none;
  max-height: 100%;
  margin-bottom: auto;
  padding: ${(0, polished_1.rem)(8)} ${(0, polished_1.rem)(2)};
  border-radius: ${({ theme }) => theme.largeBorderRadius};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.textColor};
  font-family: ${({ theme }) => theme.fontFamily};
  background-color: 'transparent';
  transition: background-color 0.1s ease;
  :hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  :focus {
    background-color: rgba(0, 0, 0, 0.1);
  }
  :active {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;
const LogoWrapper = styled_components_1.default.div `
  height: ${({ $size }) => (0, polished_1.rem)($size)};
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
const LogoImg = styled_components_1.default.img `
  max-width: 100%;
  max-height: 100%;
  height: 100%;
`;
const ChevronIcon = (0, styled_components_1.default)(Icon_1.default) `
  margin-left: ${(0, polished_1.rem)(8)};
  display: none;
  ${(0, utilities_2.mb)(550)} {
    display: initial;
  }
`;
const ResponsiveLabel = (0, styled_components_1.default)(common_1.Label) `
  display: none;
  ${(0, utilities_2.mb)('l')} {
    display: block;
    margin-left: ${(0, polished_1.rem)(12)};
  }
`;
const NoApps = styled_components_1.default.div `
  text-align: center;
  color: ${({ theme }) => theme.inactiveColor};
  font-size: ${(0, polished_1.rem)(14)};
  font-weight: 500;
  font-family: ${({ theme }) => theme.fontFamily};
`;
const NoIcon = styled_components_1.default.div `
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: ${(0, polished_1.rem)(40)};
  width: ${(0, polished_1.rem)(40)};
  background-color: #f5f5f5;
`;
const StatusBarAppSwitch = ({ app, apps, appSpace, className, theme, }) => {
    const [opened, setOpened] = react_1.default.useState(false);
    const handleClose = react_1.default.useCallback(() => {
        setOpened(false);
    }, []);
    let IconEl = null;
    if (app.logo) {
        IconEl = (react_1.default.createElement(LogoWrapper, { "$size": 24 },
            react_1.default.createElement(LogoImg, { src: app.logo, alt: app.name })));
    }
    else {
        IconEl = react_1.default.createElement(Icon_1.default, { size: "l", name: "apps", color: theme.color.primary });
    }
    const filteredApps = react_1.default.useMemo(() => {
        let result = (apps || []).filter(a => a._id !== app._id && a.appSpaceUrlPattern);
        if (appSpace) {
            result = result
                .filter(a => !a.appSpaceIds || a.appSpaceIds.includes(appSpace.app_space))
                .map(a => (Object.assign(Object.assign({}, a), { url: a.appSpaceUrlPattern.replace('{{appSpace}}', appSpace.app_space) })));
        }
        return result;
    }, [appSpace, apps, app._id]);
    if (!apps) {
        return (react_1.default.createElement(StatusBar_1.default.Item, null,
            IconEl,
            react_1.default.createElement(ResponsiveLabel, null, app.name)));
    }
    const dropdownBody = (react_1.default.createElement(Wrapper, null, filteredApps.length > 0 ? (react_1.default.createElement(Grid, null, filteredApps.map(a => {
        return (react_1.default.createElement(AppWrapper, { key: a._id, href: a.url, title: a.name, target: "_blak" },
            a.logo ? (react_1.default.createElement(LogoWrapper, { "$size": 40 },
                react_1.default.createElement(LogoImg, { src: a.logo, alt: a.name }))) : (react_1.default.createElement(NoIcon, null,
                react_1.default.createElement(Icon_1.default, { size: 24, name: "image", color: "#CECECE" }))),
            react_1.default.createElement(AppName, null, a.name)));
    }))) : (react_1.default.createElement(NoApps, null, (0, utilities_1.__)('Žiadne dostupné aplikácie')))));
    return (react_1.default.createElement(StatusBar_1.default.DropDown, { className: className, position: "left", body: dropdownBody, opened: opened, onClose: handleClose },
        react_1.default.createElement(StatusBar_1.default.Button, { active: opened, onClick: () => {
                setOpened(o => !o);
            } },
            IconEl,
            react_1.default.createElement(ResponsiveLabel, null, app.name),
            react_1.default.createElement(ChevronIcon, { name: "triangle-down", size: "m" }))));
};
exports.default = react_1.default.memo((0, styled_components_1.withTheme)(StatusBarAppSwitch));
